import { actionTypes } from '../actions/types';
import { SblStatusWeb } from '../generated-types';

type AppActions = import('../actions/types').AppActions;

export interface SblReducer {
    customerUrl: string | null;
    sblStatus: SblStatusWeb | null;
}

const initialState: SblReducer = {
    customerUrl: null,
    sblStatus: null,
};

export const SblReducer = (state = initialState, action: AppActions = {} as AppActions): SblReducer => {
    switch (action.type) {
        case actionTypes.FETCH_SBL_CONSENT_FULFILLED:
        case actionTypes.CREATE_SBL_CONSENT_FULFILLED: {
            const { customerUrl, sblStatus } = action.payload;
            return {
                ...state,
                customerUrl,
                sblStatus,
            };
        }

        case actionTypes.CREATE_SBL_CONSENT_FAILED:
        default:
            return state;
    }
};
